import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chartist = _resolveComponent("Chartist")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h6", null, "Payments")
      ])
    ], -1)),
    (_ctx.statisticsFetched)
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_Chartist, {
              class: "activity-chart activity-chart-revenue",
              labels: _ctx.labels,
              "show-point": "",
              "axis-y-label-interpolation-function": _ctx.axisYLabelInterpolationFunction,
              "tooltip-options": { currency: '$' },
              entries: _ctx.statistics,
              "entry-key": "amount",
              "entry-description-key": "date"
            }, null, 8, ["labels", "axis-y-label-interpolation-function", "entries"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_PrimeVueSkeleton, { height: "120px" })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
          key: 1,
          height: "120px"
        }))
  ]))
}